<div class="mb-2">
  <hr/>
  <div class="mt-1 mb-1 resultHeader">
    <div class="iconStyling">
        <img src="../../../../assets/images/OMIOrange.png"
          alt="{{ 'mineralInventoryIcon' | translate | async }}" 
          attr.aria-label="{{ 'mineralInventoryIcon' | translate | async }}" aria-hidden="true">
        <span class="ml-2">
          <a (click)="openInSameTab()" (dblclick)="openInNewTab()">
            {{ 'mineral.inventory.record' | translate | async }}: {{ mdi_ident }}
          </a>
        </span>
    </div>
    <div class="iconStyling recordIcon">
      <img src="../../../../assets/images/record-icon-yellow.png" 
        alt="{{ 'recordIcon' | translate | async }}" 
        attr.aria-label="{{ 'recordIcon' | translate | async }}" aria-hidden="true">
    </div>
  </div>

  <div class="resultsCardContainer">
    <div class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'name' | translate | async }}</p>
      <!-- <span *ngFor="let recordName of recordNames | orderBy: 'ranking'">

      </span> -->
      <p class="recordValue" innerHTML="{{ recordNames | orderBy: 'ranking' | commaSeparatedPipe:'md_name' | notApplicablePipe | async | highlight : this.searchTerms }}">
        {{ recordNames | orderBy: 'ranking' | commaSeparatedPipe:'md_name' | notApplicablePipe | async | highlight : this.searchTerms }}
      </p>
    </div>
    <div class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'status' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ status | highlight : this.searchTerms }}">
        {{ status | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="primaryCommodities.length > 0" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'primary.commodity' | translate | async
        }}</p>
      <p class="recordValue"
        innerHTML="{{ primaryCommodities | commaSeparatedPipe:'description' | highlight : this.searchTerms }}">
        {{ primaryCommodities | commaSeparatedPipe:'description' | highlight : this.searchTerms }}
      </p>
    </div>
    <div *ngIf="secondaryCommodities.length > 0" class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'secondary.commodity' | translate | async
        }}</p>
      <p class="recordValue"
        innerHTML="{{ secondaryCommodities | commaSeparatedPipe:'description' | highlight : this.searchTerms }}">
        {{ secondaryCommodities | commaSeparatedPipe:'description' | highlight : this.searchTerms }}
      </p>
    </div>
    <div class="flex mb-0">
      <p class="resultsCardSubtitle font-weight--bold ">{{ 'township.area' | translate | async }}</p>
      <p class="recordValue" innerHTML="{{ townships | commaSeparatedPipe:'name'  | highlight : this.searchTerms }}">
        {{ townships | commaSeparatedPipe:'name' | highlight : this.searchTerms }}
      </p>
    </div>
  </div>
</div>